import Proxy, { root } from "./Proxy";
import Observer from "./Observer";
import { getTenant, getTenantId, resolveTenant, setTenant } from "./Tenant";
import { User } from "./Types";

var user: User;
var init = false;

var _f = fetch;
var xauth: string;
try {
    xauth = localStorage.getItem('xauth');
} catch (e) { }

window.fetch = function (url: RequestInfo | URL, options?: RequestInit) {
    var result: Promise<Response> = undefined;
    try {
        if (xauth) {
            const urls = url.toString();
            if (urls[0] === '/' || urls?.startsWith(root)) {
                if (!options) {
                    options = {};
                }

                var hs = new Headers(options.headers);
                hs.append('xauth', xauth);
                options.headers = hs;

                result = _f(url, options)
            }
        }
    } catch (e) { }

    return (result || _f.apply(this, arguments)).then(x => {
        try {
            const rxauth = x.headers.get('xauth');
            if (rxauth) {
                xauth = rxauth;
                localStorage.setItem('xauth', xauth);
            }
        } catch (e) { }

        return x;
    });
}

const observer = new Observer();

const fireUserUpdate = () => observer.fire('update', [user]);

export const getUser = () => user;

export const isAdmin = () => getTenant()?.OwnerId == getUser().Id;

export const isAuthentificated = () => (user && user.IsAuthenticated);

export const isSuper = () => (isAuthentificated() && user.Name === 'SYSTEM');

const _isOwner = () => user.Tenants.find(x => x.Id === getTenantId())?.OwnerId === user?.Id;
export const isOwner = () => (isAuthentificated() && _isOwner());

export const hasRoles = () => (isAuthentificated() && (_isOwner() || !!getTenant()?.Person?.Keys?.length));

export const hasHouses = () => (isAuthentificated() && (_isOwner() || !!getTenant()?.Houses?.length));

export function hasKey(key: string) {
    return (isAuthentificated() && (_isOwner() || !!getTenant()?.Person?.Keys?.find(x => x === key)));
}

export const isInit = () => init;

export function fio() {
    const person = getTenant()?.Person;
    if (person) {
        return [person.Surname, person.Name, person.Patronomic].filter(x => x).join(' ');
    }
}

export function fioOrName() {
    return fio() || getUser()?.Name;
}

export const fetchUser = () => Proxy.get('CurrentUser')
    .then(x => {
        if (x.success) {
            init = true;

            user = x.result;

            fireUserUpdate();

            if (isAuthentificated()) {
                let t = getTenant();
                if (!t || (window as any).TenantInfo || !user.Tenants.find(x => x.Id == t!.Id)) {
                    let accId = resolveTenant();
                    if (accId) {
                        setTenantId(accId) || setTenantId();
                    } else {
                        setTenant(user.Tenants.sort((a, b) => a.Id < b.Id ? 1 : -1)[0]);
                    }
                }
            }
        }

        return user;
    });

export const generateToken = () => Proxy.get('GenerarateAuthToken');

export const setTenantId = function (id?: number) {
    var acc = id ? getUser().Tenants.find(x => x.Id == id) : null;
    if (!!acc == !!id) {
        setTenant(acc);
        return true;
    }
    else {
        return false;
    }
}

export const listenUser = (fn: Function): (() => void) => observer.listen('update', fn);

export const login = (type: string, config: any) => Proxy.post('login' + type, config)
    .then(x => {
        if (x.success && x.result.Succeeded) {
            if (x.result.XAuth) {
                localStorage.setItem('xauth', xauth = x.result.XAuth);
            }

            return fetchUser();
        }

        return x;
    });

export const register = (email: string, password: string, confirmPassword: string) =>
    Proxy.post('register', {
        email,
        password,
        confirmPassword
    })
        .then(x => {
            if (x.success && x.result.Succeeded) {
                return fetchUser();
            }

            return x;
        });

export const logout = () => {
    return Proxy.post('logout')
        .then(x => {
            try {
                xauth = '';
                localStorage.removeItem('xauth');
            } catch (e) { }

            fetchUser();
            return x;
        });
}

fetchUser();